import TableDefinitions from '../../TableDefinitions';

export const getSelection = (state, { listId }) => state.listing[TableDefinitions[listId].id].selection;

export const getSelectAll = (state, { listId }) => state.listing[TableDefinitions[listId].id].selectAll;

export const getSelectedRows = (state, { listId }) => state.listing[TableDefinitions[listId].id].selectedRows;
